import React from 'react';
import '@styles/app.css';
import { Canvas } from '@react-three/fiber';
import Scene from '@/components/Scene';
import Overlay from '@/components/Overlay';
import { Loader } from '@react-three/drei';

// performance
// https://docs.pmnd.rs/react-three-fiber/advanced/scaling-performance#movement-regression

function App() {
  console.log('app top render');

  return (
    <div className="app">
      <Overlay />
      <Canvas performance={{ current: 1, min: 0.1, max: 1, debounce: 200 }}>
        <Scene />
      </Canvas>
      <Loader />
    </div>
  );
}

export default App;
